import React from "react";
import PartnerSlider from "./component/Slider/partnerslider.js";
import { CarouselWrapper, next, prev } from "react-pretty-carousel";
import Footer from "./component/Footer.js";

function channelPartner() {
  return (
    <div className="Pricing">
      <main className="font-nunito">
        {/* Jumbotron Section Start Here */}
        <section className="pt-16">
          <div id="jumbotron">
            <img className="w-full" src="./img/pricing.webp" alt="" />
          </div>
        </section>
        {/* Jumbotron Section End Here */}
        <section className="pb-24 bg-main-color">
          <h2 className="text-white text-xl pt-11 lg:pt-11 mb-9 font-bold text-center font-nunito">
            SUBSCRIBE ON NEWS
          </h2>
          <div className="m-auto">
            <form class="flex justify-center px-6">
              <input
                class="px-4 w-full lg:w-1/4 font-poppins  border-white mr-0  border-2 text-white  bg-main-color placeholder-white"
                placeholder="your@mail.com"
                for="email"
              />
              <button class="px-8 font-poppins bg-white  text-main-color p-4   border-t border-b border-r">
                Subscribe
              </button>
            </form>
            <p className="font-poppins text-sm text-white text-center mt-5">
              Stay Up to date with the latest news
            </p>
          </div>
        </section>
        {/* SUBSCRIPTION END HERE */}

        {/*OUR PARTNERS START HERE */}
        <section className="lg:pb-28 pb-16 px-6  w-full">
          <h2 className="text-heading-color text-4xl pt-11 mb-9 lg:mb-16 font-bold text-center">
            OUR PARTNERS
          </h2>

          <div className="flex flex-col lg:flex-row lg:px-16  ">
            <div className="lg:p-6">
              <p className="text-2xl text-gray-300  font-secular">
                Our <span className="text-main-color text-3xl">Customers</span>{" "}
                Who Prefer Us on Digital Signage and Artificial Intelligence
                System
              </p>
            </div>
            <div className="lg:w-3/6 w-full lg:mx-9">
              <div className="">
                <PartnerSlider />
                {/* <div className="arrow flex justify-center lg:justify-between lg:absolute w-full top-10">
                  <button
                    className="mr-48"
                    onClick={() => {
                      next();
                    }}
                  >
                    <img src="./img/arrow-left.png" alt="" />
                  </button>
                  <button
                    onClick={() => {
                      prev();
                    }}
                  >
                    <img src="./img/arrow-right.png" alt="" />
                  </button>
                </div> */}
              </div>
            </div>
          </div>
        </section>

        {/* Follow Us */}
        <section>
          <h3 className="text-center text-main-color font-bold">
            FOLLOW US IN SOCIAL NETWORKS
          </h3>
          <div>
            <ul className="flex justify-center mt-6">
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">FACEBOOK</a>
              </li>
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">INSTAGRAM</a>
              </li>
              <li className="text-main-color text-sm xl:text-base border border-main-color px-4 xl:px-24 py-1 mx-1 xl:mx-4 hover:bg-main-color hover:border-white hover:text-white">
                <a href="#">LINKEDIN</a>
              </li>
            </ul>
          </div>
        </section>

        {/* Form */}
        <section className="pb-28 mt-10">
          <h2 className="text-heading-color text-4xl pt-11 mb-2 font-bold text-center">
            TESTIMONIALS
          </h2>
          <div className="flex lg:p-28 ">
            <div className="w-4/12 bg-gray-bg mx-4 flex flex-col justify-center items-center shadow-md relative">
              <div className="bg-main-color text-4xl px-4 font-secular absolute left-6 -top-3 text-white">
                <p className="pt-5">"</p>
              </div>

              <img className="pt-3" src="./img/testi-1.png" alt="" />
              <p className="text-center text-sm lg:text-base p-3">
                Panelo offers capability to use touchscreen display with
                interactive content to help interact and engage with your
                audience. That’s amazing technology.
              </p>
              <div className="text-center bg-white mt-3 w-full">
                <p className="font-bold">Jane Anashia</p>
                <p>Project Manager</p>
                <p>Smithson Company</p>
              </div>
            </div>
            <div className="w-4/12 bg-gray-bg mx-4 flex flex-col justify-center items-center shadow-md relative">
              <div className="bg-main-color text-4xl px-4 font-secular absolute left-6 -top-3 text-white">
                <p className="pt-5">"</p>
              </div>
              <img className="pt-3" src="./img/testi-2.png" alt="" />
              <p className="text-center lg:text-base text-sm p-3">
                Panelo offers capability to use touchscreen display with
                interactive content to help interact and engage with your
                audience. That’s amazing technology.
              </p>
              <div className="text-center  bg-white mt-3 w-full">
                <p className="font-bold">Jane Anashia</p>
                <p>Project Manager</p>
                <p>Smithson Company</p>
              </div>
            </div>
            <div className="w-4/12 bg-gray-bg mx-4 flex flex-col justify-center items-center shadow-md relative">
              <div className="bg-main-color text-4xl px-4 font-secular absolute left-6 -top-3 text-white">
                <p className="pt-5">"</p>
              </div>
              <img className="pt-3" src="./img/testi-3.png" alt="" />
              <p className="text-center lg:text-base text-sm p-3">
                Panelo offers capability to use touchscreen display with
                interactive content to help interact and engage with your
                audience. That’s amazing technology.
              </p>
              <div className="text-center bg-white mt-3 w-full">
                <p className="font-bold">Jane Anashia</p>
                <p>Project Manager</p>
                <p>Smithson Company</p>
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </div>
  );
}

export default channelPartner;
